<div>
  <h1 mat-dialog-title>Rechazos de control de calidad</h1>
  <!--  <h3></h3>-->
  <div mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onClickSave()">
      <mat-form-field appearance="fill" class="tw-w-full">
        <mat-label>Cantidad de rechazos</mat-label>
        <input
          matInput
          required
          [min]="1"
          [max]="maxQuantity"
          type="number"
          name="quantity"
          formControlName="quantity"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="tw-w-full">
        <mat-label>Turno</mat-label>
        <mat-select formControlName="shiftId" class="tw-w-full">
          <mat-option *ngFor="let item of shifts" [value]="item.id">{{
              item.title
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div mat-dialog-actions>
    <button
      mat-dialog-close
      mat-raised-button
      type="button"
      class="app-btn-close"
    >
      Cerrar
    </button>
    <button
      class="app-btn-save"
      mat-raised-button
      [disabled]="!form.valid"
      (click)="onClickSave()"
    >
      Guardar
    </button>
  </div>
</div>
